export const STATUS_COLORS = {
  green: '#85C440',
  greenBg: '#DAEDC6',
  red: '#FF0000',
  redBg: '#FFD4D4',
  blue: '#1E40AF',
  blueBg: '#DBEAFE',
  lightBlue: '#20C5E0',
  lightBlueBg: '#E0F7FA',
  yellow: '#FBC30E',
  yellowBg: '#F8EECF',
  gray: '#9E9E9E',
  grayBg: '#EEEEEE',
} as const;

export const STATUS_COLOR_MAP = {
  success: { color: STATUS_COLORS.green, bg: STATUS_COLORS.greenBg },
  error: { color: STATUS_COLORS.red, bg: STATUS_COLORS.redBg },
  info: { color: STATUS_COLORS.blue, bg: STATUS_COLORS.blueBg },
  warning: { color: STATUS_COLORS.yellow, bg: STATUS_COLORS.yellowBg },
  default: { color: STATUS_COLORS.gray, bg: STATUS_COLORS.grayBg },
} as const;
